import { createAction, props } from '@ngrx/store';
import {BlobFileMetaData} from "../../models/blob-file.model";

export const getAllBlobFileMetaData = createAction('[BlobFileList Component] Get BlobFileMetaData');

export const getAllBlobFileMetaDataSuccess = createAction(
  '[BlobFile Data Access] GetAllTenants Success',
  props<{ blobFileMetaData: BlobFileMetaData[] }>()
);

export const getAllBlobFileMetaDataFailure = createAction(
  '[Tenant Data Access] GetAllTenants Failure',
  props<{ error: string }>()
);

